export class ApplicationFeesApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getLoanFees({ loanId }) {
    return this.#http.get(`/loan/${loanId}/fee`);
  }

  async getLoanFeesReasons({ loanId }) {
    return this.#http.get(`/loan/${loanId}/fee/reasons`);
  }

  async getLoanFeesReasonsV2({ loanId }) {
    return this.#http.get(`/loan/${loanId}/fee/reasons/v2`);
  }

  async getLoanFeesReasonsHistory({ loanId }) {
    return this.#http.get(`/loan/${loanId}/fee/reasons/v2/history`);
  }

  async editLoanFeesReasonsHistory({ loanId, withLoanOptionId, ...body }) {
    return this.#http.put(`/loan/${loanId}/fee/reasons/v2/history`, body, {
      params: { withLoanOptionId },
    });
  }

  async getLoanFeesHistory({ loanId }) {
    return this.#http.get(`/loan/${loanId}/fee/history`);
  }

  async editLoanFeesReasons({ loanId, withLoanOptionId, ...body }) {
    return this.#http.put(`/loan/${loanId}/fee/reasons`, body, { params: { withLoanOptionId } });
  }

  async editLoanFeesPatch({ loanId, withLoanOptionId, ...body }) {
    return this.#http.put(`/loan/${loanId}/fee/patch`, body, { params: { withLoanOptionId } });
  }

  async getLoanFeesV2({ loanId }) {
    return this.#http.get(`/loan/${loanId}/fee/v2`);
  }

  async editLoanFeesV2({ loanId, withLoanOptionId, ...body }) {
    return this.#http.put(`/loan/${loanId}/fee/v2`, body, { params: { withLoanOptionId } });
  }

  async getLoanFeesV3({ loanId }) {
    return this.#http.get(`/loan/${loanId}/fee/v3`);
  }

  async editLoanFeesV3({ loanId, withLoanOptionId, ...body }) {
    return this.#http.put(`/loan/${loanId}/fee/v3`, body, { params: { withLoanOptionId } });
  }

  async getLoanFeeCredits({ loanId }) {
    return this.#http.get(`/loan/${loanId}/fee/credit`);
  }

  async addLoanFeeCredit({ loanId, ...body }) {
    return this.#http.post(`/loan/${loanId}/fee/credit`, body);
  }

  async deleteLoanFeeCredit({ loanId, feeCreditId }) {
    return this.#http.delete(`/loan/${loanId}/fee/credit/${feeCreditId}`);
  }

  async evaluateSectionChange({ loanId, feeTypeId, newProviderId }) {
    return this.#http.get(`/loan/${loanId}/fee/evaluate-section-change`, {
      params: { feeTypeId, newProviderId },
    });
  }
}
